function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { useTineUserFeedback } from './comment-service';
import PropTypes from 'prop-types';
import Button from "../../components/button";
import { Input } from "../../components/formelements";
import Icon from '../../components/icon';
import { Formik, Form } from "formik";
import * as Yup from "yup";
export var CommentForm = function (_ref) {
  var id = _ref.id,
    parentCommentId = _ref.parentCommentId,
    toggleCommentForm = _ref.toggleCommentForm,
    updateCommentform = _ref.updateCommentform;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    commentSubmitted = _useState2[0],
    setCommentSubmitted = _useState2[1];
  var TineUserFeedback = useTineUserFeedback();
  var postComment = async function (values, _ref2) {
    var setSubmitting = _ref2.setSubmitting;
    try {
      var payload = Object.assign({}, values, {
        parentCommentId: parentCommentId
      });
      await TineUserFeedback.postComment(payload);
      setCommentSubmitted(true);
      toggleCommentForm();
      updateCommentform();
    } catch (error) {
      console.error("Error submitting the comment:", error);
    } finally {
      setSubmitting(false);
    }
  };
  if (commentSubmitted) {
    return /*#__PURE__*/React.createElement("div", {
      className: "moderation-message"
    }, "Your comment is pending moderation.");
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "p-commentform"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      firstname: '',
      email: '',
      comment: '',
      emailnotify: false
    },
    onSubmit: postComment,
    validationSchema: Yup.object().shape({
      firstname: Yup.string().required("Navn er et obligatorisk felt"),
      email: Yup.string().email("Ugyldig e-post adresse").required("E-post er et obligatorisk felt"),
      comment: Yup.string().required("Kommentar er et obligatorisk felt").min(5, 'Kommentaren er for kort, kommentaren må være minst ${min} tegn lang')
    })
  }, function (_ref3) {
    var isSubmitting = _ref3.isSubmitting;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Input, {
      id: "comment",
      name: "comment",
      label: "Kommentar",
      as: "textarea",
      itemProp: "comment"
    }), /*#__PURE__*/React.createElement(Input, {
      id: "firstname",
      name: "firstname",
      label: "Navn",
      itemProp: "author",
      placeholder: "Fullt navn"
    }), /*#__PURE__*/React.createElement(Input, {
      itemProp: "email",
      id: "email",
      name: "email",
      label: "E-post",
      type: "email"
    }), /*#__PURE__*/React.createElement("div", {
      className: "email-notification-text"
    }, "Vi leser igjennom alle kommentarer f\xF8r de blir publisert for \xE5 sikre en god og trygg tone i kommentarfeltet. Les mer om v\xE5re debattregler ", ' ', /*#__PURE__*/React.createElement("a", {
      href: "https://www.tine.no/kontakt/artikler/ansvarserkl%C3%A6ring-personvern-og-debattregler-p%C3%A5-tines-nettsteder"
    }, "her"), "."), /*#__PURE__*/React.createElement(Input, {
      id: "emailnotify",
      name: "emailnotify",
      label: "Jeg vil motta en e-post n\xE5r noen svarer p\xE5 kommentaren",
      type: "checkbox"
    }), /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      className: "submit-comment-button",
      action: "primary",
      disabled: isSubmitting
    }, isSubmitting ? "Sender..." : "Legg inn kommentar"));
  }), /*#__PURE__*/React.createElement(Button, {
    "aria-label": "close-comment-section",
    className: "a-btn-close close-comment-button",
    onClick: function () {
      return toggleCommentForm();
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "small",
    icon: "close"
  })));
};
CommentForm.propTypes = {
  parentCommentId: PropTypes.string,
  id: PropTypes.string,
  toggleCommentForm: PropTypes.any,
  updateCommentform: PropTypes.any
};
export default CommentForm;